import { render } from "./Doorway.vue?vue&type=template&id=1ecec8f6"
import script from "./Doorway.vue?vue&type=script&lang=js"
export * from "./Doorway.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__